import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {SchedulePromotionReportData} from "./schedule-promotion-report.data";

@Injectable()
export class SchedulePromotionReportModel extends ReportModel<SchedulePromotionReportData> {
    constructor(injector: Injector) {
        super(injector, SchedulePromotionReportData);
    }
}
